import accordionFactory from './accordionFactory';

import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);

export default function() {
    const accordions = Array.from(document.querySelectorAll('.js-wholesale-catalog-accordion'));

    //accordionFactory(accordions, false, false, true).init();
	accordionFactory(accordions, false, true, false).init();

    const wholesaleNav = document.querySelector('.js-wholesale-nav');

    if (wholesaleNav) {
        const links = Array.from(wholesaleNav.querySelectorAll('a'));

        links.forEach(link => {
            link.addEventListener('click', event => {
                event.preventDefault();
                const hash = link.hash;
                if (!hash) return;
                const element = document.querySelector(hash);
                console.log(hash, element);

                const anchorEvent = new CustomEvent('anchorclick');
                document.dispatchEvent(anchorEvent);

                if (element) {
                   
                    gsap.to(window, { duration: 0.7, scrollTo: {
                        y: element,
                        offsetY: document.querySelector('.header-bottom').offsetHeight + 20
                    } });  
                }
            });
        });
    }
}
